export const FETCH_AUDIT_LOGS_BY_RESOURCE_ID = 'fetchAuditLogsByResourceId';
export const FETCH_ORGANIZATION_AUDIT_LOGS = 'fetchOrganizationAuditLogs';
